import React, { useMemo } from 'react'

import PropTypes from 'prop-types'

import { useAuth } from '@shared/hooks/auth'

const Can = ({ perform, children }) => {
  const { module } = useAuth()

  const hasPermission = useMemo(
    () => {
      return module?.permissions?.includes(perform)
    }, [perform, module]
  )

  return hasPermission ? children : <></>
}

Can.propTypes = {
  perform: PropTypes.string.isRequired,
  children: PropTypes.any.isRequired
}

export default Can
